module.exports = __webpack_public_path__ + "img/_box_live_chat.de56aef9.svg";